import { assert } from 'assert-ts';
import cn from 'classnames';
import { Children } from 'react';
import styles from './DividedList.module.css';

type ListItemComponent = React.FunctionComponent<React.HTMLProps<HTMLLIElement>>;
type ListItemElement = React.ReactElement<ListItemComponent, string | React.JSXElementConstructor<ListItemComponent>>;

type Props = {
  children: ListItemElement | ListItemElement[];
  /** Which outside borders should be shown?  Neither will be shown by default */
  outsideBorder?: 'top' | 'bottom' | 'both';
  /** Additional class names to apply */
  className?: string;
};

/**
 * Wraps a list of `li` items in a styled `ul`, with borders between each and optionally
 * on the top and/or bottom as well.
 *
 * Also gives contents the same color as our tables.
 */
export function DividedList({ children, outsideBorder, className }: Props) {
  const classes = [className, styles.DividedList];
  if (outsideBorder) {
    classes.push(styles[`DividedList___${outsideBorder}Border`]);
  }

  Children.forEach(children, (child) => {
    assert(child.type === 'li', 'expected children of DividedList to all be list items');
  });

  return <ul className={cn(classes)}>{children}</ul>;
}
